import type { LabelResolver } from '../hooks/useLabelResolver';
import type { LevelNameLocal } from '../api/types/LevelEntityLocal';
import type { Scope } from '../api/types/permissions';
import {
    fallbackLevelDisplayName,
    isLevelName,
} from '../pages/platform/tenants/levels/levelConfig';
import {
    ALL_ORGANIZATIONS,
    ORGANIZATION_GROUP_NAME,
    OTHER_SCOPE_NAME,
    PLATFORM_SCOPE_NAME,
    UNKNOWN_ORGANIZATION,
    UNNAMED_ORGANIZATION,
} from './labelConstants';

/** Nombre de la organización; sin nombre cargado, un texto genérico en vez del id. */
export function organizationName(labels: LabelResolver, tenantId: string): string {
    const name = labels.scope('TENANT', tenantId);
    return name && name !== tenantId && name !== 'TENANT' ? name : UNNAMED_ORGANIZATION;
}

/** Nombre de un nivel del tenant; sin nombre, «Nivel N» en vez de la clave. */
export function levelName(labels: LabelResolver | undefined, level: LevelNameLocal): string {
    const name = labels?.scope(level);
    return name && name !== level ? name : fallbackLevelDisplayName(level);
}

/** Alcance de un rol de plataforma, que no pertenece a ninguna organización en particular. */
export function platformRoleScopeName(scope: Scope): string {
    if (scope === 'PLATFORM') return PLATFORM_SCOPE_NAME;
    if (scope === 'TENANT') return ORGANIZATION_GROUP_NAME;
    return isLevelName(scope) ? fallbackLevelDisplayName(scope) : OTHER_SCOPE_NAME;
}

/** Alcance de la asignación de un administrador: todas las organizaciones o una por nombre. */
export function adminAssignmentScopeName(scopeRef: string, tenantName?: string): string {
    if (scopeRef === '*') return ALL_ORGANIZATIONS;
    return tenantName?.trim() || UNKNOWN_ORGANIZATION;
}
